// import Store from '../store/state'
import {loading} from '@/prototypes/u/loading'

export function afterEach (app) {
  const accessTocken = localStorage.getItem('accessToken')
  if (!app.meta.noHideLoading) {
    // Remove initial loading
    loading.hide(true)
  }
  if (accessTocken) {
    // Store.dispatch('SET_BEARER', accessTocken)
  }
}
